export default [
    {
        path: '/costs-report',
        name: 'PageCostsReportList',
        meta: { title: 'costsReport.listTitle',  roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['cost_report'] },
        component: () => import('@/pages/costs-report'),
    },
]